<!--
================================================
Un composant pour choisir une couleur de tag.

⚠️ NOTE : ce composant a été créé en dupliquant ProjectColorSelectorComp, afin d'avoir des couleurs différentes pour les tags et pour aller plus vite sans avoir à mutualiser ProjectColorSelectorComp. À terme il faudrait mutualiser ce composant avec ProjectColorSelectorComp ?

Inclus dans src/components/ModaTagManagementComp.vue

Url d'accès : http://localhost:8080/fr/samsonite/samsonite-workspace/tags

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
  <div id="TagColorSelectorComp">
    <div class="colorsBloc">
      <div class="pastille" v-for="(color, index) in colors"
           :key="index" v-bind:style="'background:#'+color.code"
           v-bind:title="$t('choisirLaCouleur',{color:color.name})"
           v-on:click="setColor(color)"
           v-bind:class="{'active':currentColor!=null && currentColor.code ==color.code}"
           v-bind:id="'color_'+color.name">
        <font-awesome-icon :icon="['fas', 'check']" class="icon"
                           v-if="currentColor!=null && currentColor.code == color.code "/>
      </div>
    </div>

  </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
// import {mapState} from 'vuex'
import SentryMixin from "../../mixins/SentryMixin.js";
// import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
import GlobalErrorNotification from "../../mixins/GlobalErrorNotificationMixin.js";
import InterceptorMixin from "../../mixins/InterceptorMixin.js";
// import _ from 'lodash'

export default {
  name: 'TagColorSelectorComp', //utile dans vue dev tool
  mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin],
  // components: {},

  props: {
    // pour typage voir :https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
    // placeholder : String, // attribut placeholder du champ
    mode: String, //  le mode dans lequel on utilise le composant : 'creation/edition'
  },
  data: function () {
    return {
      currentColor: null, // String la couleur actuelle du tag
      colors:
      // un array de couleurs attribuable à un tag
      // pris sur https://material.io/resources/color/#!/?view.left=0&view.right=0&primary.color=FF8A65 dans la colonne "300"
          [
            // {name:'red',code:'e57373'},
            // {name:'purple',code:'ba68c8'},
            // {name:'blue',code:'64b5f6'},
            // {name:'cyan',code:'4dd0e1'},
            // {name:'green',code:'81c784'},
            // {name:'amber',code:'ffd54f'},
            // {name:'orange',code:'ffb74d'},
            // {name:'blue grey',code:'90a4ae'},
            {name: 'pink', code: 'f06292'},
            {name: 'deep purple', code: '9575cd'},
            {name: 'light blue', code: '4fc3f7'},
            {name: 'deep orange', code: 'ff8a65'},
            {name: 'yellow', code: 'fbc02d'},
            {name: 'teal', code: '4db6ac'},
            {name: 'light green', code: '8bc34a'},
            // {name: 'indigo', code: '7986cb'},
            {name: 'blue grey', code: '90a4ae'},
            {name: 'grey', code: '757575'},
            {name: 'brown', code: 'a1887f'},

          ],


      locale: this.$route.params.locale

      // pour les composants où l'user est identifié ///////////////////////
      // organizationSlug: this.$route.params.organization
      // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug
      // componentIsReady : false, // indique quand le composant est prêt à être afficher
      // =================================================================
    }
  },

  computed: {
    // computed props for store :
    // ...mapState({
    //     user: state => state.user
    // }),

    //----------------------------------------------

    // vuex 2-way data binding forms https://vuex.vuejs.org/guide/forms.html#two-way-computed-property
    // email: {
    //     get () {return this.$store.state.user.email},
    //     set (value) {this.$store.commit('UpdateUserEmail', value)}
    // },

    //----------------------------------------------

    // other computed props :
    selectedColor: {
      get: function () {
        return this.currentColor
      },
      // set: function (newValue) {this.foo = newValue}
    }

  },
  watch: {
    // à chaque fois que la prop computed change
    selectedColor: function () {
      this.$root.$emit('tag_color_selected', this.selectedColor)
    }
  },


  methods: {

    /**
     * Retourne une couleur au hasard depuis this.colors
     **/
    randomColor: function () {
      let color = this.colors[Math.floor(Math.random() * this.colors.length)];
      return color;
    },

    /**
     * Définit la couleur active dans le sélecteur
     * @param color String (code couleur au format hexadécimal sans le dièse, ex : 00adee)
     * @return {*}
     */
    setColor: function (color) {
      return this.currentColor = color;
    }


  },

  // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
  mounted: function () {

    /*
     * Listener sur l'event show_modal_tag_management
     * Définit une couleur aléatoire quand la ModalTagManagement est affichée en mode creation.
     * @param mode String (edition/creation)
     * @param tag Object L'object tag (mode édition uniquement)
    */
    this.$root.$on('show_modal_tag_management', (mode, tag) => {

      switch (mode) {
        case  'creation':
          this.setColor(this.randomColor());
          break;

        case 'edition':
          // on hydrate la couleur du sélecteur avec celle du tag
          this.setColor({code: tag.color});
          break;
      }


    })

  }
}
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/css/globalVar.scss";
/*@import "../assets/css/bulmaResponsiveDep.scss";*/

#TagColorSelectorComp {
  /*width: 13rem;*/
  margin: 0.5rem auto;
}

.colorsBloc {
}

.pastille {
  border: none;
  $size: 2rem;
  height: $size;
  width: $size;
  border-radius: 3rem;
  cursor: pointer;
  margin: 0 0.7rem;
  display: inline-flex;
  position: relative;
  transition: border-radius 0.3s;

  &:hover {
    border-radius: 0.3rem;
  }


  &.active {
    border-radius: 0.3rem;
    transition: border-radius 0.3s;
  }

  .icon {
    position: absolute;
    color: white;
    margin-top: 0.3rem;
    margin-left: 0.5rem;
    font-weight: bold;
    font-size: 1.1rem;
  }
}
</style>
